import axios from 'axios';
import { SERVICE, STORAGE } from '../constants/services';
import Cookies from 'universal-cookie';
import Swal from 'sweetalert2';

const cookies = new Cookies();

export const api = async (
  prefix = "",
  payload = {},
  method = "",
  tokenSend = true,
  retry = 0,
  endPoint = SERVICE.API_URL,
  token = localStorage.getItem("token") && localStorage.getItem("token") != null ? localStorage.getItem("token") : ""
) => {
  let isFormData = payload instanceof FormData;
  let custom_header
  if (token !== "") {
    custom_header = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      cache: "no-cache",
      pragma: "no-cache",
      "cache-control": "no-cache",
      'X-App-Origin': 'https://invirtiendoplus.com.mx',
      'access-control-allow-origin': 'https://invirtiendoplus.com.mx',
    };
  }
  else {
    custom_header = {
      Authorization: `Bearer ${sessionStorage.getItem(STORAGE.ACCESS_TOKEN)}`,
      "Content-Type": "application/json",
      cache: "no-cache",
      pragma: "no-cache",
      "cache-control": "no-cache",
      'X-App-Origin': 'https://invirtiendoplus.com.mx',
      'access-control-allow-origin': 'https://invirtiendoplus.com.mx',

    };
  }
  if (tokenSend === false) {
    custom_header = {
      "Content-Type": "application/json",
      cache: "no-cache",
      pragma: "no-cache",
      "cache-control": "no-cache",
      'X-App-Origin': 'https://invirtiendoplus.com.mx',
      'access-control-allow-origin': 'https://invirtiendoplus.com.mx',
    };
  }
  if (isFormData) {
    delete custom_header["Content-Type"];
  }
  const config = {
    method,
    headers: custom_header
  };
  if (method !== "GET") {
    config.data = payload;
  }

  return await fetchRety(endPoint + prefix, config, retry);
};

const fetchRety = async (url, config, n) => {
  return new Promise((resolve, reject) => {
    axios(url, {
      ...config,
    })
      .then(({ status, data }) => {
        return resolve({ status, data: data });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
         
        }

        if (n < 1) {
          return reject(error);
        } else {
          setTimeout(function () {
            fetchRety(url, config, n - 1)
              .then(({ status, data }) => {
                return resolve({ status, data: data });
              })
              .catch((error) => {
                return reject(error);
              });
          }, 500);
        }
      });
  });
};
